export const RaMessages = {
  loadingSingle: 'Carregando RA...',
  loadingAll: 'Buscando RAs...',
  numberRequiredArgument: 'O número do RA é obrigatório',
  numberAndStoreRequiredArgument: 'O número do RA e Loja são obrigatórios',
  imageIdRequiredArgument: 'O id da imagem é obrigatório',
  notFound: 'Nenhum dado sobre esse RA foi encontrado.',
  imageNotFound: 'Não foi possível obter a imagem solicitada.',
  selectOnlyOneRaToSeePendency: 'Por favor, selecione apenas 1 RA para ver as pendências',
  selectOneRaToSeePendency: 'Por favor, selecione 1 RA para ver as pendências',
  selectAtLeastOneRaToExport: 'Por favor, selecione pelo menos 1 RA antes de prosseguir',
};

export const StoreMessages = {
  codeRequiredArgument: 'O código da loja é obrigatório.',
};

export const DocumentTypesMessages = {
  fetchError: 'Não foi possível obter os tipos de documento',
  requiredArguments: 'Informe os parâmetros corretamente',
};

export const LogMessages = {
  requiredArguments: 'Informe os parâmetros corretamente',
};

export const AuthMessages = {
  requiredArguments: 'Os dados de autenticação são obrigatórios',
  successAuthentication: 'Login efetuado com sucesso!',
};

export const VehicleMessages = {
  loadingSingle: 'Carregando...',
  loadingAll: 'Buscando...',
  numberRequiredArgument: 'A placa é obrigatória',
  imageIdRequiredArgument: 'O id da imagem é obrigatório',
  storeRequiredArgument: 'A loja é obrigatória',
};

export const FeatureControlMessages = {
  requiredFeature: 'Informe o parâmetro da feature',
  requiredStore: 'Informe a loja para checar a feature',
}

